/* eslint-disable max-lines */
import { computed } from 'mobx';
import { Trans } from 'react-i18next';
import { Env } from 'src/core/Environment';
import { RoutePaths } from 'src/core/router/RoutePaths';
import { featureList } from 'src/featureList';
import { AgentLoanApplicationDetailsPage } from 'src/pages/AgentLoanApplicationDetailsPage/AgentLoanApplicationDetailsPage';
import { AgentLoanApplicationsPage } from 'src/pages/AgentLoanApplicationsPage/AgentLoanApplicationsPage';
import { LoanApplicationDetailsPage } from 'src/pages/LoanApplicationDetailsPage/LoanApplicationDetailsPage';
import { LoanApplicationsPage } from 'src/pages/LoanApplicationsPage/LoanApplicationsPage';
import { MerchantDetailsPage } from 'src/pages/MerchantDetailsPage/MerchantDetailsPage';
import { MerchantsPage } from 'src/pages/MerchantsPage/MerchantsPage';
import { PartnerDetailsPage } from 'src/pages/PartnerDetailsPage/PartnerDetailsPage';
import { PartnerEditPage } from 'src/pages/PartnerEditPage/PartnerEditPage';
import { PartnerCreatePage } from 'src/pages/PartnersCreate/PartnerCreatePage';
import { PartnersPage } from 'src/pages/PartnersPage/PartnersPage';
import { TransactionsPage } from 'src/pages/TransactionsPage/TransactionsPage';
import { RouteDefinition } from 'src/stores/RouterStore/RouterStore.types';
import {
    filterMenuItems,
    ifFeatureUnavailable,
} from 'src/stores/RouterStore/utils';
import { UserStore } from 'src/stores/UserStore/UserStore';

export class RouterStoreClass {
    @computed get routes(): RouteDefinition[] {
        if (Env.isAgentPortal) {
            return [
                {
                    key: RoutePaths.loanApplications,
                    path: RoutePaths.loanApplications,
                    Component: AgentLoanApplicationsPage,
                    menuTitle: () => (
                        <Trans i18nKey="App.Header.Menu.AgentApplications" />
                    ),
                    menuLink: RoutePaths.loanApplications,
                    menuHide: false,
                    exact: true,
                    unavailable: UserStore.canNot.view.agentLoanApplications,
                },
                {
                    key: RoutePaths.loanApplicationDetails,
                    path: RoutePaths.loanApplicationDetails,
                    Component: AgentLoanApplicationDetailsPage,
                    menuHide: true,
                    exact: true,
                    unavailable: UserStore.canNot.view.agentLoanApplications,
                },
            ];
        }

        return [
            {
                key: RoutePaths.partners,
                path: RoutePaths.partners,
                Component: PartnersPage,
                menuTitle: () => <Trans i18nKey="App.Header.Menu.Partners" />,
                menuLink: RoutePaths.partners,
                menuHide: false,
                exact: true,
                unavailable: ifFeatureUnavailable([
                    UserStore.canNot.view.partners,
                    featureList.partners.unavailable,
                ]),
            },
            {
                key: RoutePaths.partnersCreate,
                path: RoutePaths.partnersCreate,
                Component: PartnerCreatePage,
                exact: true,
                unavailable: ifFeatureUnavailable([
                    UserStore.canNot.manage.partners,
                    featureList.partners.unavailable,
                ]),
            },
            {
                key: RoutePaths.partnersDetails,
                path: RoutePaths.partnersDetails,
                Component: PartnerDetailsPage,
                menuHide: true,
                exact: true,
                unavailable: ifFeatureUnavailable([
                    UserStore.canNot.view.partners,
                    featureList.partners.unavailable,
                ]),
            },
            {
                key: RoutePaths.partnersEdit,
                path: RoutePaths.partnersEdit,
                Component: PartnerEditPage,
                menuHide: true,
                exact: true,
                unavailable: ifFeatureUnavailable([
                    UserStore.canNot.manage.partners,
                    featureList.partners.unavailable,
                ]),
            },
            {
                key: RoutePaths.merchants,
                path: RoutePaths.merchants,
                Component: MerchantsPage,
                menuTitle: () => <Trans i18nKey="App.Header.Menu.Merchants" />,
                menuLink: RoutePaths.merchants,
                menuHide: false,
                exact: true,
                unavailable: ifFeatureUnavailable([
                    UserStore.canNot.view.merchants,
                    featureList.merchants.unavailable,
                ]),
            },
            {
                key: RoutePaths.merchantDetails,
                path: RoutePaths.merchantDetails,
                Component: MerchantDetailsPage,
                menuHide: true,
                exact: true,
                unavailable: ifFeatureUnavailable([
                    UserStore.canNot.view.merchants,
                    featureList.merchants.unavailable,
                ]),
            },
            {
                key: RoutePaths.loanApplications,
                path: RoutePaths.loanApplications,
                Component: LoanApplicationsPage,
                menuTitle: () => (
                    <Trans i18nKey="App.Header.Menu.Applications" />
                ),
                menuLink: RoutePaths.loanApplications,
                menuHide: false,
                exact: true,
                unavailable: ifFeatureUnavailable([
                    UserStore.canNot.view.loanApplications,
                    featureList.loanApplications.unavailable,
                ]),
            },
            {
                key: RoutePaths.loanApplicationDetails,
                path: RoutePaths.loanApplicationDetails,
                Component: LoanApplicationDetailsPage,
                menuHide: true,
                exact: true,
                unavailable: ifFeatureUnavailable([
                    UserStore.canNot.view.loanApplications,
                    featureList.loanApplications.unavailable,
                ]),
            },
            {
                key: RoutePaths.transactions,
                path: RoutePaths.transactions,
                Component: TransactionsPage,
                menuTitle: () => (
                    <Trans i18nKey="App.Header.Menu.Transactions" />
                ),
                menuLink: RoutePaths.transactions,
                menuHide: false,
                exact: true,
                unavailable: ifFeatureUnavailable([
                    UserStore.canNot.view.transactions,
                    featureList.transaction.unavailable,
                ]),
            },
        ];
    }

    @computed get menuItems(): RouteDefinition[] {
        return filterMenuItems(this.routes);
    }
}

export const RouterStore = new RouterStoreClass();
